import createBrowserHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import debug from './lib/debug';

const history = createBrowserHistory({});
const { REACT_APP_GA_ACCOUNT_ID: gaAccountId } = process.env;

// Only wire up GA if we are tracking
if (gaAccountId) {
  const logGA = debug({ src: 'history', method: 'main', logic: 'google-analytics-init' });

  ReactGA.initialize(gaAccountId);

  logGA(`📊 Wired up Google Analytics: ${gaAccountId}`);
}

export default history;



// WEBPACK FOOTER //
// ./src/history.js